import * as S from '../components/Static.styles'

const defaultProps = {}
const propTypes = {}

export const WritingBestPractices = () => {
  return (
    <S.Article>
      <S.Header>
        <S.Title>Writing Best Practices</S.Title>
      </S.Header>
      <S.Content>
        <p>
          Writing for TrialSite---Connect with a Worldwide Audience Hungry for
          Objective Health & Medical Research Summaries and Reports
        </p>
        <p>
          TrialSite News is disrupting health and medical-related scientific
          communications with the world’s first social authoring network
          combined with a media platform with worldwide readership. One
          principle behind TrialSite’s success has been that we take relatively
          complex to complex scientific research and breakdown and simplify for
          wider audiences. Ultimately scientists and other medical professionals
          such as physicians and nurses appreciate the easier to digest and
          consume content.
        </p>
        <p>
          Our goal with TrialSite is to make health and medical scientific
          research content easy to read and to understand, eliminating some of
          the jargon, acronyms and other “code-speak” moving away from dry and
          abstract, to more lively, dynamic and relevant to a broader audience.
          Although most scientific progress occurs not in revolutionary cycles
          but rather incrementally, over time. Thus, medical scientific progress
          may be more difficult to write about but it’s key here to learn to do
          just that for the TrialSite audience.
        </p>
        <p>
          If you want to maximize success writing for the TrialSite we must
          learn to translate our medical and health-related scientific output
          into common language that’s easily understood by a wider audience. In
          TrialSite the secret to success involves the translation of research
          content into more simplified, yet dynamic and interesting for a more
          public audience.
        </p>
        <p>
          TrialSite has spent the last few years working to improve what’s known
          as the layperson summary, also called a significance statement, or
          nontechnical summary is authored in an accessible language, briefly
          describing the research results (or other health and medical
          research-focused endeavor) in accessible language. Briefly describe
          your study hypothesis, research findings or health policy related
          output in terms that are understandable to an educated person without
          the specialized training associated with the scientific topic.
        </p>
        <p>Writing for TrialSite? We recommend the following principles:</p>
        <p>
          In the <strong>first paragraph</strong> describe the core themes or
          highest-level challenges you seek to address with your research
        </p>
        <p>
          Then in the next few sentences you should describe the context of your
          topic, whether it’s answering a hypothesis or taking on a complex
          research-focused health policy.
        </p>
        <p>
          In the <strong>second paragraph</strong> consider a summary of the
          primary study methods used to come to your conclusion. Typically this
          represents three to five sentences where you remain as objective as
          possible; acknowledge competitive research propositions for example
          yet articulate why you think your approach may advance the field. Note
          that the background paragraph establishes the need for the study,
          methods, approach or even technology tool used in drug development for
          example.
        </p>
        <p>
          As you author your third paragraph, focus on your thesis, hypothesis
          or research methods. Introduce the experiment summary (if a study) and
          highlight whether it was a randomized controlled trial, observational,
          registry or other measure. Keep this section under five sentences if
          possible.
        </p>
        <p>
          The <strong>fourth paragraph</strong> should emphasize a summary
          breakdown of the findings of the study or research effort. What are
          the study results? Keep to a few sentences if possible and showcase
          data backing your evidence. Remember the more objective and unbiased
          you sound the more credibility is the article.
        </p>
        <p>
          In the <strong>fifth paragraph</strong> if possible secure a quote,
          bringing a human element into the article. Remember we at TrialSite
          are working diligently to bring personality and human interest into
          science. Why was the study important? Or what was notable about the
          partnership or collaboration? How supportive was the trial site staff?
          What are the classes of patients that can benefit?
        </p>
        <p>
          For the <strong>sixth paragraph</strong> introduce limitations. The
          more you are open to the challenges in your own work the more you will
          connect with others—consider assumptions in place that are relevant
          for the study findings. For objective studies, think about limitations
          and assumptions that could shift your findings.
        </p>
        <p>
          Finally in the <strong>seventh paragraph</strong> summarize with a two
          to four sentence connecting how the research could someday be used
          while linking the conclusion back to the high-level problem statement
          or hypotheses started toward the beginning of the piece.
        </p>
        <p>
          Remember that different studies have different conclusions and that
          your goal is to simplify enough so that the reader can make
          his/her/their own conclusion. Ideally you avoid using TrialSite for
          more biased arguments. How did the research support the assumptions or
          hypothesis behind the high-level challenges identified upfront?
        </p>
        <p>
          TrialSite Dos and Don’ts for a concise, objective, well-written
          communication involving health and medical science related topics.
        </p>
        <p>
          Consider a specific audience (e.g., audience as at least B.S. of
          sciences)
        </p>
        <ul>
          <li>
            <p>
              Remember context is key---what does your research matter? How does
              it matter? What are the obstacles or challenges?
            </p>
          </li>
          <li>
            <p>
              Remember you are not writing academic treatises here at
              TrialSite—always remember to go back to ‘Keep it Simple, even
              casual as we do not want to bore our audience
            </p>
          </li>
          <li>
            <p>
              Where and when possible be specific about research findings,
              demonstrate or showcase quantitative or qualitative progress in a
              disease or in a clinical trial, or for that matter observational
              study at major health system or individual that wants to
              capitalize on the platform to build an audience, drive insight or
              even connect with sponsors and investors for future research.
            </p>
          </li>
          <li>
            <p>
              Remember to remain as objective as possible. While you don’t have
              to write that way, we find the best results as so much content in
              health and research scientific communications is highly biased.
              People come to TrialSite for a more objective, independent point
              of view.
            </p>
          </li>
        </ul>
      </S.Content>
    </S.Article>
  )
}

WritingBestPractices.defaultProps = defaultProps
WritingBestPractices.propTypes = propTypes

export default WritingBestPractices
